export default __webpack_public_path__ + "static/media/complainIcon3.1e485559.webp";